import { Component, OnInit } from '@angular/core';
import { MenuService } from './../../services/menu.service';

@Component({
  selector: 'app-hamburger',
  templateUrl: './hamburger.component.html',
  styleUrls: ['./hamburger.component.scss']
})
export class HamburgerComponent implements OnInit {

  burgerFlipped: boolean;

  constructor(private _menuService: MenuService) { }

  ngOnInit() {
    this._menuService.currentMenuState.subscribe(burgerFlipped => this.burgerFlipped = burgerFlipped);
  }

  flipBurger() {
    if (this.burgerFlipped) {
      this._menuService.setMenuState(false);
    } else {
      this._menuService.setMenuState(true);
    }
  }

}



// WEBPACK FOOTER //
// /Users/nicholasmurray/Documents/firebase-websites/CommunityAdviceNMD/src/app/components/hamburger/hamburger.component.ts